import Block from "@/components/wrappers/block"
import styles from "./button.module.css"
import Button from "@/common/button/button"
import classNames from "classnames/bind"
import { parse } from "next-useragent"
import InApp from "detect-inapp"

export default function CoreButton({ block, settings = {} }) {
  if (!block.attrs.url) {
    return null
  }

  const cx = classNames.bind(styles)
  const blockClasses = {
    "button-block": true,
    "has-width": block.attrs.width,
    "width-25": block.attrs.width === 25,
    "width-50": block.attrs.width === 50,
    "width-75": block.attrs.width === 75,
    "width-100": block.attrs.width === 100,
    "multiple-wrap": settings?.layout?.flexWrap === "wrap" && settings.multiple
  }

  const handleClick = (e) => {
    const ua = parse(window.navigator.userAgent)
    const inApp = new InApp(window.navigator.userAgent)

    if (block?.attrs?.uaConditional && ua.isIos && inApp.isInApp) {
      e.preventDefault()
    }
  }

  return (
    <Block block={block} noStyling={true} className={cx(blockClasses)}>
      <Button
        tagName="a"
        ariaLabel={block.text}
        theme={block.attrs.theme}
        href={block.attrs.url}
        target={block.attrs.target}
        className="button"
        onClick={(e) => handleClick(e)}>
        {block.text}
      </Button>
    </Block>
  )
}
